



const jmlIndexPeluang = (datax) => {
    var data = datax.index_peluang;
    var nilai = 0;
    datax.forEach(el => {
        nilai = nilai + el.index_peluang
    });
    return nilai
}


const ikm = (datax) =>{
    var nIndexPeluang = jmlIndexPeluang(datax);
    var nIKM = nIndexPeluang * 25
    return nIKM.toFixed(1)
}


const uraian = (datax) =>{
    var data = ikm(datax);


    if (data >= 88.31) {
        return 'Sangat Baik'   
    }
    else if(data < 88.31 && data >= 76.61){
        return 'Baik'
    }
    else if(data < 76.61 && data >= 65.00){
        return 'Kurang Baik'
    }
    else if(data < 65.00 && data >= 25){
        return 'Tidak Baik'
    }

    else {
        return 'Buruk'
    }
}






module.exports = {
    jmlIndexPeluang : jmlIndexPeluang,
    ikm : ikm,
    uraian : uraian

}